import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { MechanicService } from '../../business-services/mechanic.service';

@Injectable({ providedIn: 'root' })
export class EditMechanicServiceGuard  {

  constructor(
    private mechanicService: MechanicService,
    private router: Router
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.mechanicService.mechanicId && this.mechanicService.dealerId) {
      return true;
    }
    return this.router.createUrlTree(['/mechanic']);
  }
}
